// extracted by mini-css-extract-plugin
export default {"header":"TableHeader_header__RQMjW","emptyCell":"TableHeader_emptyCell__cTCrY","headerCell":"TableHeader_headerCell__YRjcG","title":"TableHeader_title__T-zA7"};